import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';
import type { MapResponse } from './types';

export * from './types';
export * from './mapView';

/**
 * The org's customer locations and warehouses for the wall map.
 *
 * Polls, because this is meant to sit on a wall unattended. The endpoint only
 * reads stored coordinates, so it is cheap to leave running all day.
 */
export function useMapLocations() {
  return useQuery<MapResponse>({
    queryKey: ['org:map:locations'],
    queryFn: async () => (await api.get('/organization/map/locations')).data,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
